import { useState, useEffect } from "react";
import "./formA.css";
import { handleDataFile, handleDataProject, handleDataNews } from "../../utils/fireStoreFunction";

export default function AdminForm({ editData }) {
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [link, setLink] = useState("");
  const [name, setName] = useState("");
  const [textlink, setTextLink] = useState("");
  const [chickdata, setChickData] = useState("");
  const [id, setId] = useState(null); // لإدارة حالة التعديل
  const [loading, setLoading] = useState(false); // لإدارة حالة التحميل
  const [message, setMessage] = useState(""); // حالة لإدارة الرسائل

  useEffect(() => {
    if (editData) {
      setId(editData.id);
      setName(editData.name || "");
      setImage(editData.image || "");
      setTitle(editData.title || "");
      setText(editData.text || "");
      setLink(editData.link || "");
      setTextLink(editData.textlink || "");
      setChickData(editData.type || "");
    }
  }, [editData]);

  const handleSubmit = async (e, type) => {
    e.preventDefault();
    setLoading(true);
    let result;
    switch (type) {
      case "file":
        result = await handleDataFile(id, name, image, title, text, link, textlink);
        break;
      case "project":
        result = await handleDataProject(id, title, image, link, textlink);
        break;
      case "news":
        result = await handleDataNews(id, title);
        break;
      default:
        result = { success: false, error: "Invalid type" };
    }
    if (result.success) {
      setMessage("Document successfully written!");
      // إعادة تعيين الحقول بعد الإرسال الناجح
      setName("");
      setImage("");
      setTitle("");
      setText("");
      setLink("");
      setTextLink("");
      setId(null); // إعادة تعيين حالة التعديل
    } else {
      setMessage(`Error writing document: ${result.error}`);
    }
    setLoading(false);
  };

  const renderForm = (type) => (
    <form onSubmit={(e) => handleSubmit(e, type)} className="form-container">
      {type !== "news" && (
        <>
          {type === "file" && (
            <div className="form-group">
              <label>Name File:</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" />
            </div>
          )}
          <div className="form-group">
            <label>Upload Image:</label>
            <input type="url" value={image} onChange={(e) => setImage(e.target.value)} className="form-control" />
          </div>
          <div className="form-group">
            <label>Title:</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control" />
          </div>
          {type === "file" && (
            <div className="form-group">
              <label>Text:</label>
              <input type="text" value={text} onChange={(e) => setText(e.target.value)} className="form-control" />
            </div>
          )}
          <div className="form-group">
            <label>Link:</label>
            <input type="url" value={link} onChange={(e) => setLink(e.target.value)} className="form-control" />
          </div>
          <div className="form-group">
            <label>TextLink:</label>
            <input type="text" value={textlink} onChange={(e) => setTextLink(e.target.value)} className="form-control" />
          </div>
        </>
      )}
      {type === "news" && (
        <div className="form-group">
          <label>Title:</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control" />
        </div>
      )}
      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? "Processing..." : id ? "Update" : "Submit"}
      </button>
    </form>
  );

  return (
    <div className="admin--form">
      <h3 className="admin--form__title">Add Admin</h3>
      <div className="admin--form__header">
        <button className="admin--form__header-button" onClick={() => setChickData("file")}>Files</button>
        <button className="admin--form__header-button" onClick={() => setChickData("project")}>Project</button>
        <button className="admin--form__header-button" onClick={() => setChickData("news")}>Title</button>
      </div>
      {chickdata === "file" && renderForm("file")}
      {chickdata === "project" && renderForm("project")}
      {chickdata === "news" && renderForm("news")}
      {message && <p className="massage_alert">{message}</p>} {/* عرض الرسالة */}
    </div>
  );
}